var _marker, _marker2, _marker3, _rect, _rect2, _text, _text2, _line, _rect3, _text3, _text4, _text5, _line2, _rect4, _text6, _text7, _line3, _text8, _line4, _text9, _rect5, _text0, _text1, _line5, _circle, _text10, _circle2, _text11, _circle3, _text12, _line6, _text13, _rect6, _text14, _text15, _line7, _rect7, _text16, _text17, _text18, _text19, _text20, _rect8, _text21, _text22, _text23, _text24, _text25, _rect9, _text26, _text27, _text28, _text29, _text30, _line8, _line9, _line0, _line1, _rect0, _text31, _text32, _line10, _rect1, _text33, _text34, _line11, _rect10, _text35, _text36, _text37, _rect11, _text38, _text39, _text40, _rect12, _text41, _text42, _text43;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNestedCvPipeline(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1100,
    height: 720,
    viewBox: "0 0 1100 720",
    xmlns: "http://www.w3.org/2000/svg",
    fontFamily: "Inter, system-ui, sans-serif",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _marker || (_marker = /*#__PURE__*/React.createElement("marker", {
    id: "ac",
    markerWidth: 8,
    markerHeight: 8,
    refX: 8,
    refY: 3,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,6 L8,3 z",
    fill: "#06B6D4"
  }))), _marker2 || (_marker2 = /*#__PURE__*/React.createElement("marker", {
    id: "ag",
    markerWidth: 8,
    markerHeight: 8,
    refX: 8,
    refY: 3,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,6 L8,3 z",
    fill: "#22c55e"
  }))), _marker3 || (_marker3 = /*#__PURE__*/React.createElement("marker", {
    id: "ap",
    markerWidth: 8,
    markerHeight: 8,
    refX: 8,
    refY: 3,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,6 L8,3 z",
    fill: "#a78bfa"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bgGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#0c1628"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#060c14"
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1100,
    height: 720,
    fill: "url(#bgGrad)",
    rx: 12
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1100,
    height: 720,
    fill: "none",
    rx: 12,
    stroke: "rgba(255,255,255,0.06)",
    strokeWidth: 1
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 550,
    y: 36,
    textAnchor: "middle",
    fill: "#e2e8f0",
    fontSize: 16,
    fontWeight: 700
  }, "Nested Cross-Validation \u2014 Conceptual Overview")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 550,
    y: 55,
    textAnchor: "middle",
    fill: "#7dd3fc",
    fontSize: 10
  }, "Outer loop estimates accuracy \xB7 Inner loop runs grid search to tune each classifier \xB7 prevents data leakage and inflated results")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 36,
    y1: 68,
    x2: 1064,
    y2: 68,
    stroke: "rgba(255,255,255,0.07)",
    strokeWidth: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 80,
    width: 640,
    height: 56,
    rx: 6,
    fill: "#0a1628",
    stroke: "#22c55e",
    strokeWidth: 1.5
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 550,
    y: 102,
    textAnchor: "middle",
    fill: "#22c55e",
    fontSize: 11,
    fontWeight: 700
  }, "Feature Matrix \u2014 Input")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 550,
    y: 120,
    textAnchor: "middle",
    fill: "#86efac",
    fontSize: 9
  }, "117 PCA components per participant \xB7 reduced from 11,844 features \xB7 95.1% variance retained")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 550,
    y: 131,
    textAnchor: "middle",
    fill: "#64748b",
    fontSize: 8.5
  }, "StandardScaler applied within each pipeline fold")), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 550,
    y1: 136,
    x2: 550,
    y2: 152,
    stroke: "#06B6D4",
    strokeWidth: 1.5,
    markerEnd: "url(#ac)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 154,
    width: 1048,
    height: 62,
    rx: 6,
    fill: "#061220",
    stroke: "#06B6D4",
    strokeWidth: 2
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 550,
    y: 178,
    textAnchor: "middle",
    fill: "#06B6D4",
    fontSize: 12,
    fontWeight: 700
  }, "OUTER LOOP \u2014 5-Fold Cross-Validation")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 550,
    y: 198,
    textAnchor: "middle",
    fill: "#64748b",
    fontSize: 9
  }, "Splits all data into 5 folds \xB7 each iteration holds 1 fold as TEST and uses the other 4 as TRAIN \xB7 produces 5 independent accuracy scores")), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 185,
    y1: 216,
    x2: 185,
    y2: 250,
    stroke: "#06B6D4",
    strokeWidth: 1.5,
    markerEnd: "url(#ac)"
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 202,
    y: 238,
    fill: "#7dd3fc",
    fontSize: 8.5
  }, "TEST fold")), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 717,
    y1: 216,
    x2: 717,
    y2: 250,
    stroke: "#a78bfa",
    strokeWidth: 1.5,
    markerEnd: "url(#ap)"
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 734,
    y: 238,
    fill: "#c4b5fd",
    fontSize: 8.5
  }, "TRAIN set")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 252,
    width: 318,
    height: 168,
    rx: 6,
    fill: "#061220",
    stroke: "#06B6D4",
    strokeWidth: 1.5,
    strokeDasharray: "7,4"
  })), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 185,
    y: 278,
    textAnchor: "middle",
    fill: "#7dd3fc",
    fontSize: 11,
    fontWeight: 700
  }, "Outer TEST Set")), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 185,
    y: 296,
    textAnchor: "middle",
    fill: "#475569",
    fontSize: 9
  }, "Held out \u2014 completely protected")), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 42,
    y1: 306,
    x2: 332,
    y2: 306,
    stroke: "rgba(6,182,212,0.1)",
    strokeWidth: 1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 324,
    r: 3.5,
    fill: "#ef4444",
    opacity: 0.7
  })), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 64,
    y: 328,
    fill: "#94a3b8",
    fontSize: 9
  }, "Not used in grid search")), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 346,
    r: 3.5,
    fill: "#ef4444",
    opacity: 0.7
  })), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 64,
    y: 350,
    fill: "#94a3b8",
    fontSize: 9
  }, "Not used in feature selection (SFS)")), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 368,
    r: 3.5,
    fill: "#ef4444",
    opacity: 0.7
  })), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 64,
    y: 372,
    fill: "#94a3b8",
    fontSize: 9
  }, "Not used during model training")), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 42,
    y1: 384,
    x2: 332,
    y2: 384,
    stroke: "rgba(6,182,212,0.1)",
    strokeWidth: 1
  })), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 185,
    y: 406,
    textAnchor: "middle",
    fill: "#7dd3fc",
    fontSize: 9,
    fontWeight: 600
  }, "\u2192 Only used to score the final model")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 252,
    width: 714,
    height: 218,
    rx: 6,
    fill: "#0e0820",
    stroke: "#a78bfa",
    strokeWidth: 2
  })), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 717,
    y: 278,
    textAnchor: "middle",
    fill: "#a78bfa",
    fontSize: 12,
    fontWeight: 700
  }, "INNER LOOP \u2014 3-Fold CV on TRAIN set")), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 717,
    y: 296,
    textAnchor: "middle",
    fill: "#475569",
    fontSize: 9
  }, "Grid search tries every parameter configuration \xB7 3-fold CV scores each one \xB7 best config is selected")), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 376,
    y1: 308,
    x2: 1062,
    y2: 308,
    stroke: "rgba(167,139,250,0.1)",
    strokeWidth: 1
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 376,
    y: 318,
    width: 214,
    height: 106,
    rx: 4,
    fill: "rgba(167,139,250,0.06)",
    stroke: "rgba(167,139,250,0.25)",
    strokeWidth: 1
  })), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 483,
    y: 338,
    textAnchor: "middle",
    fill: "#c4b5fd",
    fontSize: 9.5,
    fontWeight: 700
  }, "SVC (RBF kernel)")), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 483,
    y: 356,
    textAnchor: "middle",
    fill: "#64748b",
    fontSize: 8.5
  }, "C: 0.01 \xB7 0.1 \xB7 1")), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 483,
    y: 373,
    textAnchor: "middle",
    fill: "#64748b",
    fontSize: 8.5
  }, "kernel: RBF")), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    x: 483,
    y: 390,
    textAnchor: "middle",
    fill: "#64748b",
    fontSize: 8.5
  }, "class_weight: balanced")), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    x: 483,
    y: 412,
    textAnchor: "middle",
    fill: "#475569",
    fontSize: 8
  }, "3 configurations")), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 604,
    y: 318,
    width: 232,
    height: 106,
    rx: 4,
    fill: "rgba(167,139,250,0.06)",
    stroke: "rgba(167,139,250,0.25)",
    strokeWidth: 1
  })), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    x: 720,
    y: 338,
    textAnchor: "middle",
    fill: "#c4b5fd",
    fontSize: 9.5,
    fontWeight: 700
  }, "Random Forest")), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    x: 720,
    y: 356,
    textAnchor: "middle",
    fill: "#64748b",
    fontSize: 8.5
  }, "max_depth: 5 \xB7 10 \xB7 25")), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    x: 720,
    y: 373,
    textAnchor: "middle",
    fill: "#64748b",
    fontSize: 8.5
  }, "n_estimators: 100")), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    x: 720,
    y: 390,
    textAnchor: "middle",
    fill: "#64748b",
    fontSize: 8.5
  }, "max_features: sqrt \xB7 class_weight: balanced")), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    x: 720,
    y: 412,
    textAnchor: "middle",
    fill: "#475569",
    fontSize: 8
  }, "3 configurations")), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 850,
    y: 318,
    width: 212,
    height: 106,
    rx: 4,
    fill: "rgba(167,139,250,0.06)",
    stroke: "rgba(167,139,250,0.25)",
    strokeWidth: 1
  })), _text26 || (_text26 = /*#__PURE__*/React.createElement("text", {
    x: 956,
    y: 338,
    textAnchor: "middle",
    fill: "#c4b5fd",
    fontSize: 9.5,
    fontWeight: 700
  }, "Gradient Boosting")), _text27 || (_text27 = /*#__PURE__*/React.createElement("text", {
    x: 956,
    y: 356,
    textAnchor: "middle",
    fill: "#64748b",
    fontSize: 8.5
  }, "max_depth: 5 \xB7 10 \xB7 25")), _text28 || (_text28 = /*#__PURE__*/React.createElement("text", {
    x: 956,
    y: 373,
    textAnchor: "middle",
    fill: "#64748b",
    fontSize: 8.5
  }, "n_estimators: 100")), _text29 || (_text29 = /*#__PURE__*/React.createElement("text", {
    x: 956,
    y: 412,
    textAnchor: "middle",
    fill: "#475569",
    fontSize: 8
  }, "3 configurations")), _text30 || (_text30 = /*#__PURE__*/React.createElement("text", {
    x: 717,
    y: 452,
    textAnchor: "middle",
    fill: "#a78bfa",
    fontSize: 9,
    fontWeight: 600
  }, "+ Sequential Forward Selection (SFS) \u2014 finds the optimal feature subset for each configuration")), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 185,
    y1: 420,
    x2: 185,
    y2: 523,
    stroke: "#06B6D4",
    strokeWidth: 1.5
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 185,
    y1: 523,
    x2: 424,
    y2: 523,
    stroke: "#06B6D4",
    strokeWidth: 1.5,
    markerEnd: "url(#ac)"
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    x1: 717,
    y1: 470,
    x2: 717,
    y2: 523,
    stroke: "#a78bfa",
    strokeWidth: 1.5
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    x1: 717,
    y1: 523,
    x2: 688,
    y2: 523,
    stroke: "#a78bfa",
    strokeWidth: 1.5,
    markerEnd: "url(#ap)"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 424,
    y: 498,
    width: 264,
    height: 50,
    rx: 5,
    fill: "#061208",
    stroke: "#22c55e",
    strokeWidth: 1.5
  })), _text31 || (_text31 = /*#__PURE__*/React.createElement("text", {
    x: 556,
    y: 520,
    textAnchor: "middle",
    fill: "#22c55e",
    fontSize: 9.5,
    fontWeight: 700
  }, "Best model \u2192 scored on outer TEST")), _text32 || (_text32 = /*#__PURE__*/React.createElement("text", {
    x: 556,
    y: 537,
    textAnchor: "middle",
    fill: "#86efac",
    fontSize: 8.5
  }, "\u2192 1 accuracy score per outer fold")), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 556,
    y1: 548,
    x2: 556,
    y2: 564,
    stroke: "#22c55e",
    strokeWidth: 1.5,
    markerEnd: "url(#ag)"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 566,
    width: 584,
    height: 52,
    rx: 5,
    fill: "#061208",
    stroke: "#22c55e",
    strokeWidth: 1
  })), _text33 || (_text33 = /*#__PURE__*/React.createElement("text", {
    x: 550,
    y: 589,
    textAnchor: "middle",
    fill: "#86efac",
    fontSize: 10,
    fontWeight: 600
  }, "5 outer scores \u2192 averaged \u2192 final unbiased accuracy")), _text34 || (_text34 = /*#__PURE__*/React.createElement("text", {
    x: 550,
    y: 607,
    textAnchor: "middle",
    fill: "#475569",
    fontSize: 8.5
  }, "Avoids inflated results that arise from naive train/test splits on small samples")), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 36,
    y1: 632,
    x2: 1064,
    y2: 632,
    stroke: "rgba(255,255,255,0.05)",
    strokeWidth: 1
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 642,
    width: 280,
    height: 68,
    rx: 6,
    fill: "rgba(34,197,94,0.05)",
    stroke: "#22c55e",
    strokeWidth: 1.3
  })), _text35 || (_text35 = /*#__PURE__*/React.createElement("text", {
    x: 245,
    y: 662,
    textAnchor: "middle",
    fill: "#22c55e",
    fontSize: 10,
    fontWeight: 700
  }, "Pr0 vs HP1 \u2014 Prodromal vs Co-twin")), _text36 || (_text36 = /*#__PURE__*/React.createElement("text", {
    x: 245,
    y: 684,
    textAnchor: "middle",
    fill: "#86efac",
    fontSize: 20,
    fontWeight: 800
  }, "~63%")), _text37 || (_text37 = /*#__PURE__*/React.createElement("text", {
    x: 245,
    y: 703,
    textAnchor: "middle",
    fill: "#475569",
    fontSize: 8.5
  }, "Random Forest \xB7 strongest result")), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 410,
    y: 642,
    width: 280,
    height: 68,
    rx: 6,
    fill: "rgba(125,211,252,0.03)",
    stroke: "#7dd3fc",
    strokeWidth: 1
  })), _text38 || (_text38 = /*#__PURE__*/React.createElement("text", {
    x: 550,
    y: 662,
    textAnchor: "middle",
    fill: "#7dd3fc",
    fontSize: 10,
    fontWeight: 700
  }, "HC2 vs Pr0 \u2014 Control vs Prodromal")), _text39 || (_text39 = /*#__PURE__*/React.createElement("text", {
    x: 550,
    y: 684,
    textAnchor: "middle",
    fill: "#93c5fd",
    fontSize: 20,
    fontWeight: 800
  }, "~59%")), _text40 || (_text40 = /*#__PURE__*/React.createElement("text", {
    x: 550,
    y: 703,
    textAnchor: "middle",
    fill: "#475569",
    fontSize: 8.5
  }, "SVC \xB7 Gradient Boosting")), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 715,
    y: 642,
    width: 280,
    height: 68,
    rx: 6,
    fill: "rgba(125,211,252,0.03)",
    stroke: "#7dd3fc",
    strokeWidth: 1
  })), _text41 || (_text41 = /*#__PURE__*/React.createElement("text", {
    x: 855,
    y: 662,
    textAnchor: "middle",
    fill: "#7dd3fc",
    fontSize: 10,
    fontWeight: 700
  }, "HC2 vs HP1 \u2014 Control vs Co-twin")), _text42 || (_text42 = /*#__PURE__*/React.createElement("text", {
    x: 855,
    y: 684,
    textAnchor: "middle",
    fill: "#93c5fd",
    fontSize: 20,
    fontWeight: 800
  }, "~58%")), _text43 || (_text43 = /*#__PURE__*/React.createElement("text", {
    x: 855,
    y: 703,
    textAnchor: "middle",
    fill: "#475569",
    fontSize: 8.5
  }, "Random Forest")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNestedCvPipeline);
export default __webpack_public_path__ + "static/media/nested-cv-pipeline.6ee145da9a1046a9d0684a83d0f971bf.svg";
export { ForwardRef as ReactComponent };